import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { Stack, type StackProps } from "@mui/material";

export function InstantPayIndicator(props: StackProps) {
  const { sx, ...restProps } = props;
  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={sx} {...restProps}>
      <CbhIcon type="bolt-filled" color={(theme) => theme.palette.instantPay?.text} size="small" />
      <Text color={(theme) => theme.palette.instantPay?.text}>InstantPay</Text>
    </Stack>
  );
}
